import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';
import { HttpClient,HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  appApi= new AppAPIConfig();
  httpOptions={};

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response'
    };
  }

  login(body){
    return this.http.post<any>(this.appApi.loginAPI, body,this.httpOptions)
  }

  logout(){
    return this.http.get<any>(this.appApi.logoutAPI,this.httpOptions)
  }


}
